export default "__VITE_ASSET__11df64cb__"